import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const DrawerCloseIcon = ({ sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon viewBox='0 0 14 14' sx={{ width: '14px', height: '14px', ...sx }} {...props}>
      <path
        d='M1.28033 0.219668C0.987438 -0.0732225 0.512558 -0.0732225 0.219668 0.219668C-0.0732225 0.512558 -0.0732225 0.987438 0.219668 1.28033L5.6893 6.75L0.219668 12.2197C-0.0732225 12.5126 -0.0732225 12.9874 0.219668 13.2803C0.512558 13.5732 0.987438 13.5732 1.28033 13.2803L6.75 7.8107L12.2197 13.2803C12.5126 13.5732 12.9874 13.5732 13.2803 13.2803C13.5732 12.9874 13.5732 12.5126 13.2803 12.2197L7.8107 6.75L13.2803 1.28033C13.5732 0.987438 13.5732 0.512558 13.2803 0.219668C12.9874 -0.0732225 12.5126 -0.0732225 12.2197 0.219668L6.75 5.6893L1.28033 0.219668Z'
        fill='#000000'
      />
    </SvgIcon>
  );
};

export default DrawerCloseIcon;
